import {
  OrderDirection,
  commonPaginationTypes,
  pageInfo,
  userDetails,
} from "../../../../../utils/commonQueryTypes";
import {
  AtsAcLdgrEdge,
  AtsAcLdgrOrderField,
} from "../../masters/supplier/queries/types";
import { AtsRfqTrnSupplyEdge } from "../quotation/comparision/queries/types";

export enum AtsStckPurchaseItemsField {
  CREATED_AT = "CREATED_AT",
  DESC = "DESC",
}
export enum PurchaseItemFilterTypes {
  ALL_ITEMS = "ALL_ITEMS",
  PENDING_ITEMS = "PENDING_ITEMS",
  APPROVED_ITEMS = "APPROVED_ITEMS",
  REJECTED_ITEMS = "REJECTED_ITEMS",
  IN_PROGRESS_ITEMS = "IN_PROGRESS_ITEMS",
}

export interface GetPurchaseItemsVar extends commonPaginationTypes {
  customer_id: number;
  orderBy: {
    direction: OrderDirection;
    field: AtsStckPurchaseItemsField;
  };
  name: string;
}

export interface AtsStckPurchaseItem {
  id: number;
  name: string;
  addr: string;
  email: string;
  mobile: string;
  c_person: string;
}

export interface AtsStckPurchaseItemsEdge {
  node: AtsStckPurchaseItem;
  cursor: string;
}

export interface GetPurchaseItemsData {
  edges: AtsStckPurchaseItemsEdge[];
  pageInfo: pageInfo;
  totalCount: number;
}

export interface GetPurchaseItemsResult {
  GetPurchaseItems: GetPurchaseItemsData;
}

export interface GetSuppliersForPOOptionsVars extends commonPaginationTypes {
  customer_id: number;
  finYrId: number;
  orderBy: {
    direction: OrderDirection;
    field: AtsAcLdgrOrderField;
  };
  name: string;
}

export interface GetSuppliersForPOOptionsNode {
  id: number;
  desc: string;
}

export interface GetSuppliersForPOOptionsEdges {
  node: GetSuppliersForPOOptionsNode;
  cursor: string;
}

export interface GetSuppliersForPOOptionsResult {
  GetSuppliersForPO: {
    edges: GetSuppliersForPOOptionsEdges[];
    pageInfo: pageInfo;
    totalCount: number;
  };
}

export interface GetSuppliersForPOResult {
  GetSuppliersForPO: {
    edges: AtsAcLdgrEdge[];
    pageInfo: pageInfo;
    totalCount: number;
  };
}

export interface AddPoResult {
  AddPo: boolean;
}
export interface AddPoVars {
  token?: string;
  customerId: number;
  finYrId: number;
  user_details: userDetails;
  input: {
    poNo: string;
    poDate: string;
    remarks: string;
    poTrns: {
      slNo: number;
      rfqTrnSlNo: number;
      udfItemDesc: string;
      itemUom: string;
      itemQty: number;
      itemRate: number;
      itemOther: number;
      itemTaxable: number;
      itemTax: number;
      itemDelvChrg: number;
      itemInstChrg: number;
      itemValue: number;
      remarks: String;
      itemDeliverySts: number;
      itemDeliveryDate: string;
      itemID: number;
      rfqTrnID: number;
      rfqID: number;
    }[];
  };
}
